let cookiesAll = Cookies.get('cookies-all') == 'true';
let cookiesEssential = cookiesAll || (Cookies.get('cookies-essential') == 'true');


$("#formUploadBtn").unbind("click").bind("click", function () {
  console.log('testtest');
   $("#selectedFile").click();
   $("#uploadFalseInput").click();
});

function checkForm(formName)
{ console.log('submission', $(this));
  $(`#${formName} span.warnRequired`).remove();
  var required=$('<span />').text(' Please complete this field.')
                            .css('padding-left', '1.0em')
                            .css('opacity', '0.5')
                            .css('font-weight','500')
                            .addClass('warnRequired');
  var emailFormat=$('<span />').text(' Please provide a valid email address.')
                            .css('padding-left', '1.0em')
                            .css('opacity', '0.5')
                            .css('font-weight','500')
                            .addClass('warnRequired');
  var ok=true;
  $(`#${formName} [required]`).each(function()
  {
      var id=$(this).attr('id');
        
      if($(this).prop('type') == 'email') {
        var checkEmail = ValidateEmail($(this).val());

        if(! checkEmail) {
          ok=false;
          $(`#${formName} label[for=${id}]`).append(emailFormat.clone());
        }


      } else if(($(this).val()=='') || (($(this).attr('type')=='checkbox') && !$(this).prop('checked')) )
      {   
          $(`#${formName} label[for=${id}]`).append(required.clone());
          ok=false;
      }
  });
  console.log('ok', ok);
  if(ok)
      $(`#${formName}`).submit();
}

function ValidateEmail(inputText)
{
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if(inputText.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}


$('#form-new-project div[submit].btn').on('click', ()=>{checkForm('form-new-project');});
$('#form-application div[submit].btn').on('click', ()=>{checkForm('form-application');});

$('.filter-item').on('click', function () {
	var target = $(this).attr('icon-target');
	$(target).toggleClass('filter-active');
});

// Scroll to 100px above the div
$(document).ready(function() {
  $('a[href^="#"]').click(function() {
      var target = $(this.hash);
      if (target.length == 0) target = $('a[name="' + this.hash.substr(1) + '"]');
      if (target.length == 0) target = $('html');
      $('html, body').animate({ scrollTop: target.offset().top-125 }, 1000);
      return false;
  });
});

// Cookies Policy
// let cookie = Cookies.get('cookie-bar');
if(!cookiesEssential){
    $('.cookie-bar').addClass('d-block');
}

$('#cookieAccept').on('click', function (e) {
  $('.cookie-bar').fadeOut('1000').removeClass('d-block');
  // Cookies.set('cookie-bar', 'true', { expires: 14 });
  Cookies.set('cookies-all', 'true', { expires: 273, secure: true }); //9 months = 273 days
  Cookies.set('cookies-essential', 'true', { expires: 90, secure: true }); //90 days = 3 months
});

$('#cookieDeny').on('click', function (e) {
  $('.cookie-bar').fadeOut('1000').removeClass('d-block');
  // Cookies.set('cookie-bar', 'true', { expires: 14 });
  Cookies.set('cookies-all', 'false', { expires: 0, secure: true }); //0 is same as delete, though they should not exist if we got here
  Cookies.set('cookies-essential', 'true', { expires: 90, secure: true }); //90 days = 3 months

});

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$('[blogFilterTag]').click(function(){
  if($(this).hasClass('active'))
    window.location.search="";
  else
    window.location.search="?tag="+$(this).html();

  $(this).toggleClass('active');
});


// Start video 1 second in
 